import React from 'react';
import './LabelValue.scss';
import { Typography } from '../Typography/Typography';
import { Button } from '../Buttons/Button/Button';
import { Icon } from '../Icon/Icon';
import { RoundedArrow } from '@assets/images/icons';
import { useNavigate } from 'react-router-dom';

export type LabelValueProps = {
    label: string;
    value?: string | number;
    navigateTo?: string;
}

export const LabelValue: React.FC<LabelValueProps> = ({
    label,
    value,
    navigateTo
}) => {

    const navigate = useNavigate();

    if (value == null || value === '') {
        return null;
    }

    return (
        <div className="label-value">
            <Typography intrinsic="p" variant="p2" color="grey1">{label}</Typography>
            <Typography intrinsic="h3" flex variant="secondary" color="secondary">
                {value}
                {navigateTo && <Button variant="icon-hover" color="grey-secondary" icon={<Icon icon={<RoundedArrow />} size={24} />} onClick={() => navigate(navigateTo)} />}
            </Typography>
        </div>
    );
};
